import { createReducer, on } from '@ngrx/store';
import { GuidelineType } from '@components/report/active/health-guideline/type-list/type-list.component';
import { reportActiveHealthGuidelineActions } from './health-guideline.actions';
import {
  ReportActiveHealthGuidelineState,
  reportActiveHealthGuidelineState
} from './health-guideline.state';

export const reportActiveHealthGuidelineReducer = createReducer(
  reportActiveHealthGuidelineState,
  on(
    reportActiveHealthGuidelineActions.fetchGuideline,
    (state): ReportActiveHealthGuidelineState => ({
      ...state,
      loading: {
        ...state.loading,
        fetchGuideline: true
      }
    })
  ),
  on(
    reportActiveHealthGuidelineActions.setGuideline,
    (state, data): ReportActiveHealthGuidelineState => ({
      ...state,
      guideline: data.guideline
    })
  ),
  on(
    reportActiveHealthGuidelineActions.fetchGuidelineSuccess,
    (state, data): ReportActiveHealthGuidelineState => ({
      ...state,
      guideline: data.guideline,
      loading: {
        ...state.loading,
        fetchGuideline: false
      }
    })
  ),
  on(
    reportActiveHealthGuidelineActions.fetchGuidelineFailed,
    (state): ReportActiveHealthGuidelineState => ({
      ...state,
      guideline: null,
      loading: {
        ...state.loading,
        fetchGuideline: false
      }
    })
  ),
  on(
    reportActiveHealthGuidelineActions.setGeneralExerciseSegment,
    (state, { segment }): ReportActiveHealthGuidelineState => ({
      ...state,
      generalExerciseExerciseSegment: segment
    })
  ),
  on(
    reportActiveHealthGuidelineActions.setGuidelineType,
    (state, { guidelineType }): ReportActiveHealthGuidelineState => ({
      ...state,
      guidelineType
    })
  ),
  on(
    reportActiveHealthGuidelineActions.setShowMorePersonalInformation,
    (state, { show }): ReportActiveHealthGuidelineState => ({
      ...state,
      showMorePersonalInformation: show
    })
  ),
  on(
    reportActiveHealthGuidelineActions.resetSelectedSection,
    (state): ReportActiveHealthGuidelineState => {
      state.generalExerciseExerciseSegment = 'moderate';
      state.showMorePersonalInformation = false;
      state.guidelineType = GuidelineType.MY_EXERCISE_GUIDELINE;
      return state;
    }
  ),
  on(
    reportActiveHealthGuidelineActions.resetUserData,
    (state): ReportActiveHealthGuidelineState => ({
      ...state,
      guideline: null
    })
  )
);
